// The privacy team owns this wording.
export const MAP_PRIVACY_NOTICE_TEXT =
  'Ao visualizar o mapa, seu IP e dados do navegador serão compartilhados com o Google.'
